










import Vue, { PropOptions } from 'vue';
import CampaignService from '../../services/CampaignService';
import { Campaign, CampaignStatus } from '@/models';
import ButtonAction from '@/components/ButtonAction.vue';
export default Vue.extend({
  data() {
    return {
      loading: false,
    };
  },
  components: { ButtonAction },
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  methods: {
    async duplicate() {
      this.loading = true;
      try {
        const newCampaign = await CampaignService.createCampaignDraft(this.campaign);
        this.$router.push(`/campaign/create?draftId=${newCampaign.objectId}`);
      } catch (error) {
        this.$store.commit('addSnackbar', {
          text: `Erro ao duplicar campanha: ${error.message}`,
        });
      }
      this.loading = false;
    },
  },
});
